"use client";

import React from "react";
import { components, GroupBase, MenuListProps, OptionProps } from "react-select";
import type { EnhancedOption } from "./types";
import "./EnhancedMenuList.css";

type Props = MenuListProps<EnhancedOption, false, GroupBase<EnhancedOption>>;

const EnhancedMenuList = (props: Props) => {
  const { children } = props;
  const isEmpty = Array.isArray(children) && children.length === 0;

  return (
    <components.MenuList {...props}>
      <div className="enhanced-menu-list">
        {isEmpty ? (
          <div className="enhanced-menu-empty">No options found</div>
        ) : (
          children
        )}
      </div>
    </components.MenuList>
  );
};

export const EnhancedOptionComponent = (props: OptionProps<EnhancedOption, false>) => {
  const { data, innerRef, innerProps, isFocused } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`enhanced-option-item ${isFocused ? "focused" : ""}`}
    >
      {data.icon && <span className="enhanced-option-icon">{data.icon}</span>}
      <div className="enhanced-option-content">
        <div className="enhanced-option-label">{data.label}</div>
        {data.description && <div className="enhanced-option-description">{data.description}</div>}
      </div>
    </div>
  );
};

export default EnhancedMenuList;
